import { render } from "./BaseLayout.vue?vue&type=template&id=63adc9c7&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=63adc9c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63adc9c7"

export default script